import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

export const getManagementDashboard = createAsyncThunk(
  'dashboard/getManagementDashboard',
  async (params, { signal }) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      url: `management-dashboard?${searchParams}`,
      method: 'get',
      signal,
    });

    return res;
  },
);

export const getEmployeesDetails = createAsyncThunk('dashboard/getEmployeeDetails', async (params, { signal }) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    url: `management-dashboard/employee-details?${searchParams}`,
    method: 'get',
    signal,
  });

  return res;
});

// Tutors
export const getTutorDetails = createAsyncThunk('dashboard/getTutorDetails', async (params, { signal }) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    url: `management-dashboard/tutor-details?${searchParams}`,
    method: 'get',
    signal,
  });
  return res;
});

// Students
export const getStudentDetails = createAsyncThunk('dashboard/getStudentDetails', async (params, { signal }) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    url: `management-dashboard/student-details?${searchParams}`,
    method: 'get',
    signal,
  });
  return res;
});

//sales
export const getSalesDetails = createAsyncThunk('dashboard/getSalesAndRetention', async (params, { signal }) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    url: `management-dashboard/sale-details?${searchParams}`,
    method: 'get',
    signal,
  });
  return res;
});

//retention
export const getRetentionDetails = createAsyncThunk('dashboard/getRetentionDetails', async (params, { signal }) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    url: `management-dashboard/retention-details?${searchParams}`,
    method: 'get',
    signal,
  });

  return res;
});

//leads
export const getLeadDeatils = createAsyncThunk('dashboard/getLeadDeatils', async (params, { signal }) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    url: `management-dashboard/lead-details?${searchParams}`,
    method: 'get',
    signal,
  });

  return res;
});

//assessment
export const getAssessmentDetails = createAsyncThunk('dashboard/getAssessmentDetails', async (params, { signal }) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    url: `management-dashboard/assessment-details?${searchParams}`,
    method: 'get',
    signal,
  });

  return res;
});
export const getRevenueOrExpenseAnalysis = createAsyncThunk(
  'dashboard/getRevenueOrExpenseAnalysis',
  async (params, { signal }) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      url: `/management-dashboard/${params?.urlPath}-analysis?${searchParams}`,
      method: 'get',
      signal,
    });

    return res;
  },
);

const initialState = {
  managementDashboard: {
    data: {},
    loading: false,
  },
  emplyeesDetails: {
    data: [],
    loading: false,
    meta: {},
  },
  tutorsDetails: {
    data: [],
    loading: false,
    meta: {},
  },
  studentsDetails: {
    data: [],
    loading: false,
    meta: {},
  },
  salesDetails: {
    data: [],
    loading: false,
    meta: {},
  },
  retentionDetails: {
    data: [],
    loading: false,
    meta: {},
  },
  leadDetails: {
    data: [],
    loading: false,
    meta: {},
  },
  assessmentDetails: {
    data: [],
    loading: false,
    meta: {},
  },
  revenueOrExpenseAnalysis: {
    data: {},
    loading: false,
  },
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getManagementDashboard.pending, (state) => {
      state.managementDashboard.loading = true;
    });
    builder.addCase(getManagementDashboard.fulfilled, (state, action) => {
      state.managementDashboard.loading = false;
      state.managementDashboard.data = action.payload?.data ?? {};
    });

    builder.addCase(getEmployeesDetails.pending, (state) => {
      state.emplyeesDetails.loading = true;
    });
    builder.addCase(getEmployeesDetails.fulfilled, (state, action) => {
      state.emplyeesDetails.loading = false;
      state.emplyeesDetails.data = action.payload?.data ?? [];
      state.emplyeesDetails.meta = action.payload?.meta ?? {};
    });

    /* --- TUTORS --- */
    builder.addCase(getTutorDetails.pending, (state) => {
      state.tutorsDetails.loading = true;
    });
    builder.addCase(getTutorDetails.fulfilled, (state, action) => {
      state.tutorsDetails.loading = false;
      state.tutorsDetails.data = action.payload?.data ?? [];
      state.tutorsDetails.meta = action.payload?.meta ?? {};
    });

    /* --- STUDENTS --- */
    builder.addCase(getStudentDetails.pending, (state) => {
      state.studentsDetails.loading = true;
    });
    builder.addCase(getStudentDetails.fulfilled, (state, action) => {
      state.studentsDetails.loading = false;
      state.studentsDetails.data = action.payload?.data ?? [];
      state.studentsDetails.meta = action.payload?.meta ?? {};
    });

    /* --- sales --- */
    builder.addCase(getSalesDetails.pending, (state) => {
      state.salesDetails.loading = true;
    });
    builder.addCase(getSalesDetails.fulfilled, (state, action) => {
      state.salesDetails.loading = false;
      state.salesDetails.data = action.payload?.data ?? [];
      state.salesDetails.meta = action.payload?.meta ?? {};
    });

    /* --- retention --- */
    builder.addCase(getRetentionDetails.pending, (state) => {
      state.retentionDetails.loading = true;
    });

    builder.addCase(getRetentionDetails.fulfilled, (state, action) => {
      state.retentionDetails.loading = false;
      state.retentionDetails.data = action.payload?.data ?? [];
      state.retentionDetails.meta = action.payload?.meta ?? {};
    });

    /* --- lead details --- */
    builder.addCase(getLeadDeatils.pending, (state) => {
      state.leadDetails.loading = true;
    });

    builder.addCase(getLeadDeatils.fulfilled, (state, action) => {
      state.leadDetails.loading = false;
      state.leadDetails.data = action.payload?.data ?? [];
      state.leadDetails.meta = action.payload?.meta ?? {};
    });

    /* --- assessment completed --- */
    builder.addCase(getAssessmentDetails.pending, (state) => {
      state.assessmentDetails.loading = true;
    });

    builder.addCase(getAssessmentDetails.fulfilled, (state, action) => {
      state.assessmentDetails.loading = false;
      state.assessmentDetails.data = action.payload?.data ?? [];
      state.assessmentDetails.meta = action.payload?.meta ?? {};
    });
    /* --- retention --- */
    builder.addCase(getRevenueOrExpenseAnalysis.pending, (state) => {
      state.revenueOrExpenseAnalysis.loading = true;
      state.revenueOrExpenseAnalysis.data = {};
    });

    builder.addCase(getRevenueOrExpenseAnalysis.fulfilled, (state, action) => {
      state.revenueOrExpenseAnalysis.loading = false;
      state.revenueOrExpenseAnalysis.data = action.payload?.data ?? [];
    });
  },
});

export default dashboardSlice.reducer;
